import React from "react";
import Topbar from "../../Layout/Header/Topbar";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";

import team_build from "../../../Assets/img/team_building.svg";
import problem_solving from "../../../Assets/img/problem_solving.svg";
import employee_eng from "../../../Assets/img/employee_eng.svg";
import team_strength from "../../../Assets/img/team_strength.svg";
import improve_prodvty from "../../../Assets/img/improve_prodvty.svg";
import list4 from "../../../Assets/img/logical.png";
import plan from "../../../Assets/img/Plan.jpg";
import design from "../../../Assets/img/Design.jpg";
import evaluate from "../../../Assets/img/Evaluate.jpg";
import experience from "../../../Assets/img/Experience.jpg";
import play from "../../../Assets/img/Play.jpg";
import Scrollchor from 'react-scrollchor';
import corporate from "../../../Assets/img/Group 2883.svg";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { ContactForm, sponsor_section } from "./contact_partials";

function PrivatePuzzled() {
  return (
    <div className="corporatepuzzled innerBody">
      <Topbar />
      <Header />
      <div className="container-fluid">
        <div className="row mt-4 mb-4">

          <div className="col-xl-5 col-lg-5 col-md-11 col-12 mt-5">
            <div className="benifits">
            <h3 className="mb-5">KEEP YOUR TEAM SHARPER</h3>

            <p>Each Puzzled level is designed with a specific purpose in mind - make sure the grey matter is tested adequately, before it is solved. In addition to our mainstream events, we also conduct private events for organizations which would want to train their team with the right problem-solving skills, and also be a means of an effective employee engagement exercise.</p>
            <br/>
            <Scrollchor to="#how_it_works" animate={{duration: 450}}>  

            <button
             type="button"
             className="btn btn-yellow g-recaptcha">
                SEE HOW IT WORKS 
            </button>

            </Scrollchor>

            </div>
          </div>

          <div className="col-xl-6 offset-xl-1 col-lg-7 col-md-12 col-12 mt-4 mb-4 corporate_bg">
            <ContactForm title="RUN A PRIVATE PUZZLED EVENT" button_name="CONTACT US"/>
            <img src={corporate} alt=""/>
          </div>

        </div>
      </div>


      <div className="container mb-5">

         <h3 className="mt-5 mb-5 text-center" id="how_it_works"> HOW IT WORKS? </h3>  


     <Tabs>
     <TabList>
       <Tab>Plan</Tab>
      <Tab>Design</Tab>
      <Tab>Play</Tab>
      <Tab>Experience</Tab>
      <Tab>Evaluate</Tab>
     </TabList>

      <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> 
            <img src={plan} alt=""/>
          </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>Define what you want to achieve with your Private Edition of Puzzled</h4> <br/>

            <p>Though, Puzzled was initially designed to cater to the small community of puzzle enthusiasts, study tells us that getting engaged in solving complex problems like this creates a strong skill-set in the individual to solve real-world problems.</p>
            <p>A Private Puzzled event could be aimed at <ul><li>Improving Problem Solving Skills of the Team</li><li>Create a Better Team Working Experience</li><li>Serve as an Effective Employee Work-Life Balance Exercise</li><li>And having some pure unadulterated fun </li></ul></p>  
        </div>

      </div>
      </TabPanel>

      <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={design} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>We do what we do best - Design tailored Puzzled levels</h4> <br/>

            <p>Once the plan of the Private Puzzled event is devised, we will then set out on creating the optimum problem solving experience for your team.</p>
            <p>As with the main edition, our Puzzle Masters make sure each level is intricately crafted to provide an absolutely cracking experience, solving each level. </p>  
        </div>

       </div>
      </TabPanel>

      <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={play} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>And so, the Games Begin!</h4> <br/>

            <p>Once the levels are ready, it is time for your team members to login to their unique accounts, to begin cracking the levels. </p>
            <p>We will have our moderation team on stand-by to answer to all of the questions the participants have, during their treacherous journey to conquer this Puzzled edition.</p>  
        </div>

      </div>
       </TabPanel>

       <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={experience} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>A Highly Interactive and Engaging Experience</h4> <br/>

            <p>The beauty of solving puzzles is heightened by the fact that the competition this time is between the closest of colleagues, as they fight to win the gold.</p>
            <p>Also, our platform is designed to show results and progress real-time to all participants alike. As the battle intensifies, team work comes to the fore in differentiating the winner from the others.</p>  
        </div>

      </div>
       </TabPanel>

       <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={evaluate} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>Evaluate, Assess and Improve</h4> <br/>

            <p>The ultimate motive of any team-building activity is to improve performance on the whole, as well as on an individual level.</p>
            <p>We, at Puzzled will provide an exhaustive list of analytical data, to help you take actionable insights on who performed well and who needs to improve. All said and done, but we guarantee you, everyone who play Puzzled will have a significant boost towards better problem-solving.</p>  
        </div>

      </div>
       </TabPanel>
      </Tabs>  

      </div>

      <div className="container-fluid" style={{paddingLeft: "0px",paddingRight: "0px" }}>

        <section className="skill-Area">
          <div className="container pt-5 pb-5">
            <div className="row justify-content-center text-center mb-6">
              <div className="col-xl-8 col-lg-9">
                <h3 className="text-center">ORGANIZATIONAL BENEFITS</h3>
              </div>
            </div>
            <div className="row text-center skills_required org_benifits">
              <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                <img src={team_build} alt="" /> <br/>
                <span> Team Building </span> <br/>
                <p>Solving the exciting puzzles as a team is sure to build a better team bonding in real-world challenges.</p>  
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                <img src={problem_solving} alt="" /> <br/>
                <span> Problem Solving </span><br/>
                <p>We would with pride dare to say that there is nothing equivalent to Puzzled in improving one's problem solving skills.</p> 
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                <img src={employee_eng} alt="" /> <br/>
                <span> Employee Engagement </span> <br/>
                <p>At these times of Covid-19, you can effectively consider Puzzled as the best alternative to your traditional pub quizzes.</p> 
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                <img src={list4} alt="" /> <br/>
                <span> Logical  Reasoning </span> <br/>
                <p>In addition to problem solving, the meticulous effort needed to solve each level, is sure to increase the logical reasoning skills of each Puzzler.</p> 
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                <img src={team_strength} alt="" /> <br/>
                <span> Improve Team Strength </span> <br/>
                <p>United we stand, divided we fall. With each level requiring different set of skills, after an edition of Puzzled, your team will realize how to play along each one's strengths.</p> 
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0">
                <img src={improve_prodvty} alt="" /> <br/>
                <span> Improve Productivity </span> <br/>
                <p>Having learnt a wide array of skills to solve problems, Puzzlers tend to take this on to their main stream work, to solve problems quicker, and with improved efficiency.</p> 
              </div>
            </div>
          </div>
        </section>

      </div>
      <div className="container mt-5 mb-4">
        {sponsor_section("CORPORATES WE HAVE WORKED WITH")}
      </div>
      <Footer />
    </div>
  );
}

export default PrivatePuzzled;
